import React from 'react';
import {
  Divider,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  table: {
    minWidth: 650
  }
});

const SalesOrderInvoiceTable = (props) => {

  const classes = useStyles();

  return (
    <TableContainer>
      <Divider/>
      { props.products.length > 0 ?
      <Table className={classes.table} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>Product ID</TableCell>
            <TableCell>Product Name</TableCell>
            <TableCell>Product Brand</TableCell>
            <TableCell align="right">Unit Price</TableCell>
            <TableCell align="right">Quantity</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.products.map((product) => (
            <TableRow key={product.displayId}>
              <TableCell component="th" scope="row">
                {product.displayId}
              </TableCell>
              <TableCell component="th" scope="row">{product.name}</TableCell>
              <TableCell component="th" scope="row">{product.company}</TableCell>
              <TableCell align="right">{product.unitPrice}</TableCell>
              <TableCell align="right">{product.quantity}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table> 
      : null }
    </TableContainer>
  )
};

export default SalesOrderInvoiceTable;